import { Component, OnInit, OnDestroy, Input, AfterViewInit, ViewChild, ElementRef, EventEmitter, Output, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { UserLogin } from '../../models/user-login.model';
import { ICD, MasterConfig, ResponseAPI, ErrorList, ICDStep3 } from '../../models/IDPReport.model';
import { SfDataService } from '../../services/sf-data.service';
import { AgentService, PreSubmitIssue } from '../../services/agent.service';
import { AiHintStateService } from '../../services/ai-hint-state.service';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { ConfigurationService } from '../../services/configuration.service';
import { Utilities } from '../../services/utilities';
import Swal from 'sweetalert2';



declare const $: any;




declare global {
  interface JQuery {
    datepicker(options?: any): any;
  }
}

interface JQuery<TElement = HTMLElement> {
  select2(options?: any): any;
}

interface JQuery {
  select2(options?: any): any;
}


// import custom validator to validate 
import { MustMatch } from '../../models/MustMatch';
import { dateNotLessThanTodayValidator } from '../../models/dateNotLessThanTodayValidator';


@Component({
    selector: 'app-sf-icd-reopenicd',
    templateUrl: './sf-icd-reopenicd.component.html',
    styleUrls: ['./sf-icd-reopenicd.component.scss'],
    standalone: false
})
export class SfIcdReopenicdComponent implements OnInit, AfterViewInit {
  icd = new ICDStep3();
  noMiddleName: boolean = false;
  data = {
    name: 'John',
    age: 30
  };

  userLogin = new UserLogin(); id: string; q: string; fm: string; d: string;
  isLoading = false;
  isTestCampaign = false;
  formResetToggle = true;
  modalClosedCallback: () => void;
  loginStatusSubscription: any;
  IsPref_Differ = false;
  selectedCountry: string;
  selected_WC_details: string
  icdForm: FormGroup;
  section1Form: FormGroup;
  section2Form: FormGroup;
  section3Form: FormGroup;
  section4Form: FormGroup;
  section5Form: FormGroup;
  section6Form: FormGroup;

  @Input()
  isModal = false;
  submitted = false;
  ddlUSStates = [];
  ddlBest_Delivery_Time = [];
  ddlCAProvinence = [];

  Canada_campaignData = [];
  Canada_retailsData = [];

  PO_namesData = [];
  NC_namesData = [];
  RC_namesData = [];


  US_campaignData = [];
  US_retailsData = [];
  icd_o = new ICD();
  @Output() dataEmitter = new EventEmitter<any>();
  @Input() inputData: any;
  selectedFiles: FileList;
  validFiles: File[] = [];
  fileData: { attachment_FileName: string, attachment_Base64: string, attachment_Type: string }[] = [];
  maxFilesAllowed: number = 15; // Maximum number of files allowed
  maxFileSize: number = 26214400; // Maximum file size in bytes (5MB)

  US_Retails_selectedItems: any[] = [];
  US_Retails_isSelectedItemsinvalid = false;
  Canada_Retails_selectedItems: any[] = [];
  Canada_Retails_isSelectedItemsinvalid = false;
  US_Campaigns_selectedItems: any[] = [];
  US_Campaigns_isSelectedItemsinvalid = false;
  Canada_Campaigns_selectedItems: any[] = [];
  Canada_Campaigns_isSelectedItemsinvalid = false;

  // ---- Due Diligence campaign gating (ported from sf-icd-create) ----
  // Shown BEFORE the reopen form. Answering "No" skips straight to the form;
  // "Yes" requires selecting a Promoting Owner -> New ICD Owner -> campaign(s),
  // then Proceed reveals the existing reopen form (the loaded owner is left as-is).
  iSDueDelValue: string = '';
  iSDueDelYes = false;
  IsDueDelVis = true;
  IsFormVis = false;
  searchText: string = '';
  filteredOwners: any[] = [];
  AccPodata: any = [];
  selected_AccPo: string;
  selected_AccPoRep: string;
  selected_camp: string;
  isrepLoading = false;
  isPOICDNO = false;
  AccPoRepdata: any = [];
  AccPoRepdataNF: any = [];
  campsdata: any = [];
  campsdatafilter: any = [];
  Campaigns_selectedItems: any[] = [];
  Campaigns_isSelectedItemsinvalid = false;
  repdata: any[] = [];

  isOTPValid = false;
  btnDisplay = true;
  // Pre-submit review
  showPreSubmitReview = false;
  preSubmitIssues: PreSubmitIssue[] = [];
  preSubmitLoading = false;

  public masterConfig: MasterConfig[] = [];

  datad = {
    name: '',
    age: 0
  };

  @Output() idEmitter = new EventEmitter<string>();
  //@ViewChild('dobInput') dobInput: ElementRef;
  @ViewChild('datepicker') datepicker: ElementRef;
  @ViewChild('selectEl') selectEl: ElementRef;

  select2Options = {
    placeholder: 'Select an option...',
    width: '100%'
  };

  selectedOption: string;
  controlDisplayNames: { [key: string]: string } = {

    US_or_CA: 'Country',

    Owner_First_Name: 'Owner First Name',
    Owner_Last_Name: 'Owner Last Name',
    Owner_Middle_Name: 'Owner Middle Name',

    Full_Legal_Company_Name: 'Full Legal Company Name',

    Tax_ID: 'Tax ID',

    Owner_Preferred_First_Name: 'Preferred First Name',
    Owner_Preferred_Last_Name: 'Preferred Last Name',

    Is_Preferred_Differ: 'Preferred Name Different',

    Provinence_of_Incorporation: 'Province Of Incorporation',
    State_of_Incorporation: 'State Of Incorporation',

    Date_of_Incorporation: 'Date Of Incorporation',

    Owner_Email: 'Owner Email'
  };

  fieldMaxLengths: any = {
    Tax_ID: 25,
    Owner_Preferred_First_Name: 255,
    Owner_Preferred_Last_Name: 255,
    Owner_Email: 80
  };

  constructor(private route: ActivatedRoute, private elRef: ElementRef, private fb: FormBuilder, private router: Router, private alertService: AlertService, private authService: AuthService, private configurations: ConfigurationService, private sfDataService: SfDataService, private agentService: AgentService, private hintStateService: AiHintStateService) { }

  @Output() activateTab = new EventEmitter<number>();

  ngOnInit(): void {


    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Attempting login...');
    //this.emitActivateTab(3);
    $('.detailchild').removeClass('active');
    $('.detailmain').removeClass('active');
    $('#custom-tabs-four-more-tab').addClass('active');

    $('.detailchild').removeClass('tabhighlight');
    $('#custom-tabs-reopen-icd').addClass('tabhighlight');
    $('#custom-tabs-four-more-tab').parent().addClass('active');

    this.id = this.route.snapshot.paramMap.get('id');


    this.fm = this.route.snapshot.paramMap.get('f');

    this.d = this.route.snapshot.paramMap.get('dcode');
     

    this.datad = this.inputData;
    this.CreateForm();

    this.BindDropdowns();
     
        this.idEmitter.emit(this.id);
        this.BindData(this.id);
       

  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event: Event): void {
    event.preventDefault();
  }
  ShowOTPpopup(str: string) {
    Swal.fire({
      title: 'OTP!',
      text: str,
      icon: 'warning',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,
      input: 'text',
      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (!val) {
          Swal.showValidationMessage("OTP is required");
        } else {
          try {

            // Create a new instance of the ICD class
            let responseAPI = new ResponseAPI();
            this.sfDataService.getOTP(this.id, val, this.q)
              .subscribe(
                data => {

                  //responseAPI = data;
                  // Assign the received data to the responseAPI object
                  responseAPI = data;
                  if (responseAPI.isSuccess) {
                    this.isOTPValid = responseAPI.isSuccess;
                    this.idEmitter.emit(this.id);
                    this.BindData(this.id);
                  }
                  else {
                    // API call failed, reject the Promise to prevent closing the popup
                    this.ShowOTPpopup("Wrong Access Code, Enter Access Code to continue");
                  }

                },
                error => {

                  this.alertService.stopLoadingMessage();

                  if (Utilities.checkNoNetwork(error)) {
                    this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
                    this.offerAlternateHost();
                  } else {
                    const errorMessage = Utilities.getHttpResponseMessage(error);

                    if (errorMessage) {
                      this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
                    } else {
                      this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
                    }
                  }

                  setTimeout(() => {
                    this.isLoading = false;
                  }, 500);
                });

            // await this.apiService.postData(val);
            // API call succeeded, resolve the Promise
          } catch (error) {
            // API call failed, reject the Promise to prevent closing the popup
            return Promise.reject(error);
          }
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Handle success case when the API call is successful
      } else if (result.isDenied) {
        // Handle the case when the user cancels the dialog
      } else if (result.isDismissed) {
        // Handle the case when the dialog is closed without confirmation
      }
    });
  }
   


  CreateForm() {
    this.icdForm = this.fb.group({
      US_or_CA: ['', Validators.required],
      Owner_First_Name: [{ value: '', disabled: true }],
      Owner_Last_Name: [{ value: '', disabled: true }],
      Owner_Middle_Name: [{ value: '', disabled: true }],
      Full_Legal_Company_Name: [{ value: '', disabled: true }],
      Tax_ID: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Tax_ID), this.noHtmlTagsValidator.bind(this)]],
      Owner_Preferred_First_Name: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Preferred_First_Name), this.noHtmlTagsValidator.bind(this)]],
      Owner_Preferred_Last_Name: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Preferred_Last_Name), this.noHtmlTagsValidator.bind(this)]],
      Is_Preferred_Differ: ['', Validators.required],
      Provinence_of_Incorporation: ['', Validators.required],
      State_of_Incorporation: ['', [Validators.required]],
      Date_of_Incorporation: ['', [Validators.required, Validators.pattern(/^(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])\-\d{4}$/)]],

      Owner_Email: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Email), this.noHtmlTagsValidator.bind(this)]],
       

      HUB_Manager_Contact_Name: [{ value: '', disabled: true }],
      HUB_Manager_Contact_Number: [{ value: '', disabled: true }],
      HUB_Manager_Contact_Email: [{ value: '', disabled: true }],
       

    });


  }



  onIsPreferChange(Is_Preferred_Differ) {

    if (Is_Preferred_Differ === 'Yes') {
      this.IsPref_Differ = true;
      this.icdForm.get('Owner_Preferred_First_Name').setValidators([Validators.required]);
      this.icdForm.get('Owner_Preferred_Last_Name').setValidators([Validators.required]);

    } else {
      this.IsPref_Differ = false;
      this.icdForm.get('Owner_Preferred_First_Name').clearValidators();
      this.icdForm.get('Owner_Preferred_Last_Name').clearValidators();
      this.icdForm.controls['Owner_Preferred_First_Name'].setValue('');
      this.icdForm.controls['Owner_Preferred_Last_Name'].setValue('');
    }
    this.icdForm.get('Owner_Preferred_First_Name').updateValueAndValidity();
    this.icdForm.get('Owner_Preferred_Last_Name').updateValueAndValidity();

  }

  sendDataToParent() {
    this.dataEmitter.emit(this.datad);
  }
  // convenience getter for easy access to form fields
  get f() { return this.icdForm.controls; }

  get s1() { return this.section1Form.controls; }

  get items(): FormArray {
    return this.icdForm.get('items') as FormArray;
  }



  onCountryChange() {
    const US_or_CA = this.icdForm.get('US_or_CA').value;
    if (US_or_CA === 'US') {
      this.selectedCountry = "US";
      this.icdForm.get('State_of_Incorporation').setValidators([Validators.required]);
      this.icdForm.get('Provinence_of_Incorporation').clearValidators();

       

    } else {
      this.selectedCountry = "Canada";
      this.icdForm.get('Provinence_of_Incorporation').setValidators([Validators.required]);
      this.icdForm.get('State_of_Incorporation').clearValidators();

       


    }
    this.icdForm.get('Provinence_of_Incorporation').updateValueAndValidity();
    this.icdForm.get('State_of_Incorporation').updateValueAndValidity();

     
  }

  onCheckboxChange_US_Retails(event: any, value: any) {
    if (event.target.checked) {
      this.US_Retails_selectedItems.push(value);
    } else {
      const index = this.US_Retails_selectedItems.indexOf(value);
      if (index > -1) {
        this.US_Retails_selectedItems.splice(index, 1);
      }
    }


    if (this.US_Retails_selectedItems.length <= 0) {
      this.US_Retails_isSelectedItemsinvalid = true;
    }
    else {
      this.US_Retails_isSelectedItemsinvalid = false;
    }


  }


  onCheckboxChange_Canada_Retails(event: any, value: any) {
    if (event.target.checked) {
      this.Canada_Retails_selectedItems.push(value);
    } else {
      const index = this.Canada_Retails_selectedItems.indexOf(value);
      if (index > -1) {
        this.Canada_Retails_selectedItems.splice(index, 1);
      }
    }


    if (this.Canada_Retails_selectedItems.length <= 0) {
      this.Canada_Retails_isSelectedItemsinvalid = true;
    }
    else {
      this.Canada_Retails_isSelectedItemsinvalid = false;
    }


  }


  onCheckboxChange_US_Campaigns(event: any, value: any) {

    if (event.target.checked) {
      if (value == "TestCampaign(NotListed)") {
        this.isTestCampaign = true;
        this.icdForm.get('TestCampaignNotListed').setValidators([Validators.required]);
        this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();

      }
      this.US_Campaigns_selectedItems.push(value);
    } else {
      this.isTestCampaign = false;
      this.icdForm.get('Company_Country').clearValidators();
      this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();
      const index = this.US_Campaigns_selectedItems.indexOf(value);
      if (index > -1) {
        this.US_Campaigns_selectedItems.splice(index, 1);
      }
    }


    if (this.US_Campaigns_selectedItems.length <= 0) {
      this.US_Campaigns_isSelectedItemsinvalid = true;
    }
    else {
      this.US_Campaigns_isSelectedItemsinvalid = false;
    }


  }


  onCheckboxChange_Canada_Campaigns(event: any, value: any) {
    if (event.target.checked) {
      this.Canada_Campaigns_selectedItems.push(value);
    } else {
      const index = this.Canada_Campaigns_selectedItems.indexOf(value);
      if (index > -1) {
        this.Canada_Campaigns_selectedItems.splice(index, 1);
      }
    }


    if (this.Canada_Campaigns_selectedItems.length <= 0) {
      this.Canada_Campaigns_isSelectedItemsinvalid = true;
    }
    else {
      this.Canada_Campaigns_isSelectedItemsinvalid = false;
    }


  }

  showErrorAlert(caption: string, message: string) {
    this.alertService.showMessage(caption, message, MessageSeverity.error);
  }

  // Front-end displays dates as MM-DD-YYYY; Salesforce stores them as YYYY-MM-DD.
  // Convert a UI MM-DD-YYYY value to YYYY-MM-DD before saving. Idempotent/safe for
  // empty or already-normalized values.
  private toSfDate(v: string): string {
    if (!v) { return v; }
    const m = /^(\d{2})-(\d{2})-(\d{4})$/.exec(v.trim());
    return m ? `${m[3]}-${m[1]}-${m[2]}` : v;
  }

  // Convert a Salesforce YYYY-MM-DD (optionally with a time component) to the
  // MM-DD-YYYY the datepicker/UI expects. Safe for empty/invalid values.
  private toDisplayDate(v: string): string {
    if (!v) { return v; }
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v.trim());
    return m ? `${m[2]}-${m[3]}-${m[1]}` : v;
  }

  ngAfterViewInit() {

     $('#Date_of_Incorporation').datepicker({
      dateFormat: 'mm-dd-yy',
      changeMonth: true,
      changeYear: true,
      maxDate: 0,
      // minDate: 0,
      onSelect: (dateText, inst) => {
        
        this.icdForm.controls['Date_of_Incorporation'].patchValue(dateText);
        this.icdForm.controls['Date_of_Incorporation'].markAsTouched();
        this.icdForm.controls['Date_of_Incorporation'].updateValueAndValidity();
      }
    });

    //if (this.selectEl) {
    //  $(this.selectEl.nativeElement).select2({ width: '100%' });
    //};

    //setTimeout(() => {
    //  $('.select2', this.elRef.nativeElement).select2();
    //}, 0);
    //$('.select2').select();
    //$(this.datepicker.nativeElement).datepicker({
    //  dateFormat: 'yyyy-mm-dd',
    //  autoclose: true,
    //  onSelect: (date) => {
    //    this.dobInput.nativeElement.value = date;
    //  }
    //});

    //$('.select2').select2(); //initialize 
  }

  closeModal() {
    if (this.modalClosedCallback) {
      this.modalClosedCallback();
    }
  }

  onSubmit() {
    this.hintStateService.collapse();

    this.submitted = true;
    this.trimFormValues();

    // stop here if form is invalid
    if (this.icdForm.invalid) {


      const formControls = this.icdForm.controls;

      // Initialize an array to store invalid controls
      const invalidControls: string[] = [];

      // Iterate through the form controls and check if they are invalid
      Object.keys(formControls).forEach(controlName => {
        const control = this.icdForm.get(controlName);

        if (control?.invalid) {
          let displayName =
            this.controlDisplayNames[controlName] || controlName;

          if (control.errors?.invalidHtml) {
            displayName += ' (HTML/script not allowed)';
          }
          invalidControls.push(displayName);
        }
      });

      // Now, the 'invalidControls' array contains the names of all invalid form controls
      ////console.log('Invalid controls:', invalidControls);
      const commaSeparated = invalidControls.join(', ');

      // Mark all fields as touched to display validation errors
      this.icdForm.markAllAsTouched();
      this.alertService.showMessage('Enter required fields', commaSeparated, MessageSeverity.error);
      this.Showsuccesspopup1('Enter required fields :' + commaSeparated);
      // Mark all fields as touched to display validation errors
      this.icdForm.markAllAsTouched();

      return;
    }

    this.showPreSubmitReview = true;
    this.runPreSubmitReview();

  }



  Showsuccesspopup1(str: string) {
    Swal.fire({
      title: str,
      icon: 'error',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,

      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (val) {

          //location.reload();
        }
      },
    }).then((result) => {

    });
  }


  fileValidator(control: any) {
    const files = control.value;

    if (!files || files.length === 0) {
      return null;
    }
    if (files.length + this.fileData.length > this.maxFilesAllowed) {
      return { maxFilesExceeded: true };
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!this.isValidFileFormat(file)) {
        return { invalidFormat: true };
      }

      if (file.size > this.maxFileSize) {
        return { fileSizeExceeded: true };
      }
    }

    return null;
  }

  //onFileSelected(event: any, inputId: string) {

  //  const files = event.target.files;


  //  for (let i = 0; i < files.length; i++) {
  //    const file = files[i];

  //    if (!this.isValidFileFormat(file)) {
  //      //console.log('Invalid file format:', file.name);
  //      this.icdForm.get('Attach_US_Articles_of_Incorporation').setErrors({ invalidFormat: true });

  //      continue;
  //    }

  //    const reader = new FileReader();
  //    reader.readAsDataURL(file);

  //    reader.onload = () => {
  //      const base64 = reader.result.toString().split(',')[1];
  //      this.fileData.push({ name: file.name, base64 });

  //      // Update the 'Attach_1' form control with the selected file name
  //      this.icdForm.patchValue({ Attach_US_Articles_of_Incorporation: file.name });

  //    };
  //  }

  //  this.uploadFiles();
  //}
  onFileSelected(event: any, controlName: string) {
    const files = event.target.files;
    const errors = [];
    const errorMessages: string[] = [];
    // Remove previously selected files for this control
    this.fileData = this.fileData.filter(file => file.attachment_Type !== controlName);

    if (!files || files.length === 0) {
      this.icdForm.get(controlName).setErrors({ noFileSelected: true });
      this.icdForm.get(controlName).updateValueAndValidity();
      return;
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // Check for valid file format
      if (!this.isValidFileFormat(file)) {
        errorMessages.push(
          `Invalid file format for "${file.name}". 
     Allowed formats: all image files (JPG, PNG, HEIC, etc.), PDF, Word (DOC, DOCX), Excel (XLS, XLSX), and CSV.`
        );

        //console.log('Invalid file format:', file.name);
        errors.push({ invalidFormat: true });
      }

      // Check for file size limit
      if (file.size > this.maxFileSize) {
        errorMessages.push(`File size exceeds 25 MB limit for file "${file.name}".`);
        //console.log('File size exceeds the limit:', file.name);
        errors.push({ fileSizeExceeded: true });
      }
    }

    // Set errors if any exist
    if (errors.length > 0) {
      const combinedMessage = errorMessages.join('\n');

      this.alertService.showMessage(combinedMessage, '.', MessageSeverity.error);
      this.Showsuccesspopup1(combinedMessage);
      this.icdForm.get(controlName).setErrors(errors.reduce((acc, curr) => ({ ...acc, ...curr }), {}));
      const control = this.icdForm.get(controlName);
      // 🔥 CRITICAL FIX
      control?.setValue(null);
      control?.setErrors(errors.reduce((acc, curr) => ({ ...acc, ...curr }), {}));
      control?.markAsTouched();
      control?.updateValueAndValidity({ emitEvent: false });

      // optional: clear DOM input too
      event.target.value = '';
      return; // 👈 stop here
    } else {
      const fileReaders = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();

        fileReaders.push(
          new Promise((resolve) => {
            reader.readAsDataURL(file);
            reader.onload = () => {
              const b64 = reader.result.toString().split(',')[1];
              this.fileData.push({
                attachment_FileName: file.name,
                attachment_Base64: b64,
                attachment_Type: controlName
              });
              resolve(true);
            };
          })
        );
      }

      // Wait for all files to be processed before clearing errors
      Promise.all(fileReaders).then(() => {
        this.icdForm.get(controlName).setErrors(null);
      });
    }

    // Update form control validity
    this.icdForm.get(controlName).updateValueAndValidity();
  }



  isInvalid(controlName: string): boolean {
    const control = this.icdForm.get(controlName);
    return control.touched && control.invalid;
  }


  public openFile(name: string, type: string): void {
    this.getBase64DownloadUrl(name, type).then((url: string) => {
      window.open(url, '_blank');
    });
  }

  public getBase64DownloadUrl(name: string, type: string): Promise<string> {
    const file = this.fileData.find(f => f.attachment_FileName === name && f.attachment_Type === type);

    if (file) {
      const fileExtension = this.getFileExtension(name);
      const mimeType = this.getMimeType(fileExtension);
      const base64Data = file.attachment_Base64;

      return Promise.resolve(`data:${mimeType};base64,${base64Data}`);
    } else {
      return Promise.reject(new Error('File not found.'));
    }
  }


  private getFileExtension(fileName: string): string {
    const fileExtension = fileName.split('.').pop().toLowerCase();
    return fileExtension;
  }


  private getMimeType(fileExtension: string): string {
    // Map the file extension to the corresponding MIME type
    const mimeTypeMap = {
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      xls: 'application/vnd.ms-excel',
      csv: 'text/csv'
    };

    return mimeTypeMap[fileExtension];
  }


  isValidFileFormat(file: File): boolean {
    const allowedMimePrefixes = [
      'image/' // all image types (jpg, png, heic, webp, etc.)
    ];

    const allowedExactMimeTypes = [
      // PDF
      'application/pdf',

      // Word
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

      // Excel
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

      // CSV (different browsers report it differently)
      'text/csv',
      'application/csv',
      'text/plain'
    ];

    // 1️⃣ Primary check (modern browsers)
    if (file.type) {
      if (allowedMimePrefixes.some(prefix => file.type.startsWith(prefix))) {
        return true;
      }

      if (allowedExactMimeTypes.includes(file.type)) {
        return true;
      }
    }

    // 2️⃣ Fallback (Safari / iOS / older browsers)
    const allowedExtensions = [
      // images
      'jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif',

      // documents
      'pdf', 'doc', 'docx',

      // excel
      'xls', 'xlsx',

      // csv
      'csv'
    ];

    const extension = file.name.split('.').pop()?.toLowerCase();
    return !!extension && allowedExtensions.includes(extension);
  }


  uploadFiles() {
    //const formData = new FormData();

    //for (let i = 0; i < this.validFiles.length; i++) {
    //  formData.append('files[]', this.validFiles[i]);
    //}

    //console.log(this.fileData)
    //this.http.post('https://example.com/upload', formData).subscribe(
    //  (response) => {
    //    //console.log('Upload successful', response);
    //  },
    //  (error) => {
    //    //console.log('Upload error', error);
    //  }
    //);
  }


  // Check if the first five fields are valid
  areFirstFiveFieldsValid(firstFiveFields: any): boolean {


    for (const fieldName of firstFiveFields) {
      const fieldControl = this.icdForm.get(fieldName);
      if (fieldControl && fieldControl.invalid) {
        return false;
      }
    }

    return true;
  }

  // Example implementation of getErrorMessage function
  getErrorMessage(fieldName: string): string {
    const control = this.icdForm.get(fieldName);

    if (control?.errors) {
      if (control.errors.required) {
        return 'This field is required.';
      }
      if (control.errors.invalidHtml) {
        return 'HTML or script content is not allowed.';
      }
      // Add additional error messages for specific validation rules as needed
    }

    return 'Invalid field.';
  }

  saveData(isSubmitted: boolean) {
    //debugger;
    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data Submitting...');
    this.btnDisplay = false;
    // Get the form values as an object
    const formValues = this.icdForm.getRawValue();



    // Set the properties of the ICD instance with the form values
    this.icd.US_or_CA = formValues.US_or_CA;
    //this.icd.Full_Legal_Company_Name = formValues.Full_Legal_Company_Name;
    // this.icd.Years_in_Business = formValues.Years_in_Business;

    this.icd.Tax_ID = formValues.Tax_ID;
     
    //this.icd.Owner_First_Name = formValues.Owner_First_Name;
    //this.icd.Owner_Last_Name = formValues.Owner_Last_Name;
    this.icd.Owner_Preferred_First_Name = formValues.Owner_Preferred_First_Name;
    this.icd.Owner_Preferred_Last_Name = formValues.Owner_Preferred_Last_Name;
    this.icd.Owner_Email = formValues.Owner_Email;
    this.icd.Preferred_Name_Different_from_Legal_Name__c = formValues.Is_Preferred_Differ;

    this.icd.Date_of_Incorporation = this.toSfDate(formValues.Date_of_Incorporation);
    if (this.icd.US_or_CA == "US") {
      this.icd.State_of_Incorporation = formValues.State_of_Incorporation;
      this.icd.Provinence_of_Incorporation = "";
    }
    else {
      this.icd.Provinence_of_Incorporation = formValues.Provinence_of_Incorporation;
      this.icd.State_of_Incorporation = "";
    }

    // Attach the Due Diligence campaigns selected in the gate. Guarded by
    // !IsDueDelVis so campaigns only submit when the user went through Proceed
    // (the "No" path clears Campaigns_selectedItems and never sets IsDueDelVis=false via Proceed).
    if (this.Campaigns_selectedItems.length > 0 && !this.IsDueDelVis) {
      const uniqueCampaigns = [...new Set(this.Campaigns_selectedItems)];
      this.icd.Campaigns = uniqueCampaigns.join(', ');
    }

    this.icd.IsSubmitted = isSubmitted;
    //console.log(this.icd);
    this.SaveDatatoDB();

  }


  ShowSuccesspopup() {
    Swal.fire({
      title: 'Data Saved Successfully!',
      icon: 'success',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,

      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (val) {

        }
      },
    }).then((result) => {
      let url = '/icdreport/';
      this.router.navigate([url]);
    });
  }

  SaveDatatoDB() {
    Swal.fire({
      title: 'Submitting data...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    // Create a new instance of the ICD class
    let responseAPI = new ResponseAPI();
    this.sfDataService.CreateReOpen(this.icd)
      .subscribe(
        data => {
          Swal.close();
          //responseAPI = data;
          // Assign the received data to the responseAPI object
          responseAPI = data;
          if (responseAPI.isSuccess && !responseAPI.isValidationError) {
            /*location.reload();*/


            this.alertService.showMessage('ICD', `Data Saved Successfully`, MessageSeverity.success);
            this.alertService.stopLoadingMessage();
            this.isLoading = false;
            this.ShowSuccesspopup();


            //setTimeout(() => {
            //  this.alertService.showMessage('ICD', `Data Saved Successfully`, MessageSeverity.success);
            //  this.alertService.stopLoadingMessage();
            //  this.isLoading = false;


            //}, 200);
          }
          else {

            let errors = new ErrorList();
            errors = responseAPI.data;
            //setTimeout(() => {
            this.alertService.showMessage('ICD', `Error while saving Data`, MessageSeverity.error);
            this.alertService.stopLoadingMessage();
            this.isLoading = false;
            this.alertService.showStickyMessage('Unable to store data', errors.error.message, MessageSeverity.error, errors.error.errorCode);


            //}, 200);

          }

        },
        error => {
          Swal.close();
          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });

  }

  numberValidator(control: FormControl) {
    const isValid = /^\d+$/.test(control.value);
    return isValid ? null : { 'invalidNumber': true };
  }

  BindDropdowns() {
    //debugger;
    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');

    //this.icd.Owner_Email = this.icdForm.value["Owner_email"];
    this.sfDataService.getMasterConfigs("US_State,Canada_Province,US_Retails,US_Campaigns,Canada_Retails,Canada_Campaigns,DeliveryTime")
      .subscribe(
        data => {
          ////console.log(data);
          //debugger;
          this.masterConfig = data;
          this.ddlUSStates = this.masterConfig.filter(a => a.type == "US_State");
          this.ddlCAProvinence = this.masterConfig.filter(a => a.type == "Canada_Province");
          //this.Canada_campaignData = this.masterConfig.filter(a => a.type == "Canada_Campaigns");
          //   this.Canada_retailsData = this.masterConfig.filter(a => a.type == "Canada_Retails");
          // this.US_campaignData = this.masterConfig.filter(a => a.type == "US_Campaigns");
          //  this.US_retailsData = this.masterConfig.filter(a => a.type == "US_Retails");
          this.ddlBest_Delivery_Time = this.masterConfig.filter(a => a.type == "DeliveryTime");
          this.alertService.stopLoadingMessage();
        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });

    this.sfDataService.getCMReports().subscribe(resp => {
      ////console.log(resp);

      let res: any;

      res = resp;

      this.Canada_campaignData = res.filter(a => a.country == "CAN" && a.status != "Ended");
      this.US_campaignData = res.filter(a => a.country == "USA" && a.status != "Ended");

      // Due Diligence campaign master list for the reopen DD gate (Due Diligence only).
      this.campsdata = res.filter(a => a.dueDiligenceRequired == "Yes");

      var TestCampaign = {
        attributes: null,
        backgroundCheck: "Yes",
        campaignName: "TestCampaign(NotListed)",
        channel: "TestCampaign(NotListed)",
        country: "USA",
        drugScreen: "No",
        id: "a1122334455",
        legacyCampaignInfo: null,
        name: "TestCampaign(NotListed)",
        status: "Production",
        supplementalBackground: null
      }
      this.US_campaignData.push(TestCampaign);
      ////console.log(this.US_campaignData)

      //      //console.log(this.Canada_campaignData)
    });


    this.sfDataService.getRetails().subscribe(resp => {
      ////console.log(resp);

      let res: any;

      res = resp;

      this.Canada_retailsData = res.filter(a => a.isDeleted == "false");
      this.US_retailsData = res.filter(a => a.isDeleted == "false");
      ////console.log(this.US_campaignData)

      ////console.log(this.Canada_campaignData)
    });

    this.sfDataService.getAddInfoDDs().subscribe(resp => {
      ////console.log(resp);

      let res: any;

      res = resp;

      this.NC_namesData = res.ncNames.filter(a => a.isDeleted == "false");
      this.RC_namesData = res.rcNames.filter(a => a.isDeleted == "false");
      this.PO_namesData = res.poNames.filter(a => a.isDeleted == "false");
      //$('.select2').select();
      ////console.log(this.NC_namesData)

      ////console.log(this.Canada_campaignData)
    });

    // Promoting Owners (account hubs) for the reopen Due Diligence owner search table.
    this.sfDataService.GetAccountHubs().subscribe(resp => {
      this.AccPodata = resp;
    });

    //$('.select2').select2();

  }

  // ==================================================================
  // Due Diligence campaign gating (ported from sf-icd-create).
  // On reopen this runs BEFORE the existing form; proceed() only reveals
  // the form and stashes the selected campaigns — it does NOT overwrite the
  // owner/country loaded from the existing ICD.
  // ==================================================================

  oniSDueDel(yesorno) {
    this.iSDueDelValue = yesorno;

    // Clear any owner/rep/campaign selection made under the previous answer so
    // a campaign chosen under "Yes" (but never confirmed via Proceed) can't be
    // submitted after switching to "No".
    this.resetDueDiligenceSelection();

    if (yesorno == 'Yes') {
      this.IsDueDelVis = true;
      this.IsFormVis = false;
      this.iSDueDelYes = true;
    }
    else {
      this.IsDueDelVis = false;
      this.IsFormVis = true;
      this.iSDueDelYes = false;
    }
  }

  filterOwners() {
    // Require at least 3 characters before filtering; exclude test accounts.
    if (this.searchText.trim().length >= 3) {
      this.filteredOwners = this.AccPodata.filter(owner =>
        (owner?.ownerName ?? '').toLowerCase().includes(this.searchText.toLowerCase()) &&
        owner?.test_Account__c == 'false'
      );
    } else {
      this.filteredOwners = [];
      this.selected_AccPo = '';
    }
  }

  onCheckbox_AccPO(selectElement: any) {
    if (selectElement != null) {
      this.selected_AccPo = selectElement.ownerName;
      this.AccPoRepdata = [];
      this.AccPoRepdataNF = [];

      // Changing the Promoting Owner invalidates the previously chosen New ICD
      // Owner and its campaign list.
      this.isPOICDNO = false;
      this.resetRepAndCampaignSelection();

      this.isLoading = true;
      this.alertService.startLoadingMessage('', 'Data loading...');
      this.sfDataService.GetAccountReps(selectElement.ownerName, this.selected_camp).subscribe(resp => {
        this.AccPoRepdataNF = resp;
        // Sort newest-first before dedup so that when a rep has multiple SF
        // records under the same owner, the most recent one (and its closed
        // date) is the one kept and checked against the 90-day rule below.
        // Matches sf-icd-create's GetAccountReps handling.
        const sorted = resp.sort((a, b) =>
          new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
        );
        this.AccPoRepdata = sorted.filter((item, index, self) =>
          index === self.findIndex((t) => t.icD_Rep_Name === item.icD_Rep_Name)
        );

        this.AccPoRepdata.forEach(item => {
          item.closedDate = this.formatDate(item.closedDate);
        });

        this.alertService.stopLoadingMessage();
        this.isLoading = false;
        this.isrepLoading = true;

        if (this.isPOICDNO) {
          this.onCheckbox_AccPORepOwnerName(this.selected_AccPo);
        }
      });
    }
    else {
      this.selected_AccPo = "";
      this.isrepLoading = false;
      this.AccPoRepdataNF = [];
      this.AccPoRepdata = [];
      this.isPOICDNO = false;
      this.resetRepAndCampaignSelection();
    }
  }

  togglePOICDO(event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.isPOICDNO = isChecked;
      this.onCheckbox_AccPORepOwnerName(this.selected_AccPo);
    } else {
      this.isPOICDNO = false;
      this.onCheckbox_AccPORep('');
    }
  }

  getFilteredAccPoRep(): any[] {
    if (!this.AccPoRepdata || !Array.isArray(this.AccPoRepdata)) {
      return [];
    }
    const ownerName = (this.selected_AccPo ?? '').toString().trim().toLowerCase();
    return this.AccPoRepdata.filter(item => {
      const original = (this.AccPoRepdataNF || []).find((r: any) => r.icD_Rep_Name === item.icD_Rep_Name) || item;
      const repName = (original.icD_Rep_Name ?? '').toString().trim().toLowerCase();
      const recordOwner = (original.icD_Owner_Name__c ?? '').toString().trim().toLowerCase();
      if (repName === '' || repName === ownerName || (recordOwner !== '' && repName === recordOwner)) {
        return false;
      }
      return this.isClosedWithin90Days(original);
    });
  }

  onCheckbox_AccPORep(selectElement) {
    if (selectElement != null) {
      this.selected_AccPoRep = selectElement;
      this.repdata = this.AccPoRepdataNF
        .filter((a: any) => a.icD_Rep_Name == selectElement)
        .filter((rep: any) => this.isClosedWithin90Days(rep));
      this.buildCampaignFilter();
    }
    else {
      this.selected_AccPoRep = "";
    }
  }

  onCheckbox_AccPORepOwnerName(selectElement) {
    if (selectElement != null) {
      this.selected_AccPoRep = selectElement;
      this.repdata = this.AccPoRepdataNF
        .filter((a: any) => a.icD_Owner_Name__c == selectElement)
        // "Existing Owner Opening a New Corp": only the owner's own records count.
        .filter((rep: any) => {
          const repName = (rep.icD_Rep_Name ?? '').toString().trim();
          const ownerName = (rep.icD_Owner_Name__c ?? '').toString().trim();
          return repName === '' || repName === ownerName;
        })
        .filter((rep: any) => this.isClosedWithin90Days(rep));
      this.buildCampaignFilter();
    }
    else {
      this.selected_AccPoRep = "";
    }
  }

  private buildCampaignFilter(): void {
    const filtered = this.campsdata.filter((camp: any) =>
      this.repdata.some(rep => rep.campaign_Name === camp.campaignName)
    );

    const seen = new Set<string>();
    this.campsdatafilter = filtered.filter((camp: any) => {
      const key = (camp.campaignName ?? '').toString().trim().toLowerCase();
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });

    this.Campaigns_selectedItems = [];
    this.Campaigns_isSelectedItemsinvalid = false;
  }

  onCheckboxChange_Campaigns(event: any, value: any) {
    if (event.target.checked) {
      this.Campaigns_selectedItems.push(value);
    } else {
      const index = this.Campaigns_selectedItems.indexOf(value);
      if (index > -1) {
        this.Campaigns_selectedItems.splice(index, 1);
      }
    }
    this.Campaigns_isSelectedItemsinvalid = this.Campaigns_selectedItems.length <= 0;
  }

  proceed() {
    if (this.Campaigns_selectedItems.length > 0) {
      // Reopen keeps the owner/country already loaded from the existing ICD.
      // Proceed only reveals the reopen form; the selected campaigns are attached
      // to the payload later in saveData().
      this.IsDueDelVis = false;
      this.IsFormVis = true;
    }
    else {
      this.alertService.showMessage('Campaign', `Please select min 1 campaign listed`, MessageSeverity.error);
    }
  }

  showAllDueDiligenceCampaigns() {
    const dueDiligenceCampaigns = this.campsdata.filter(camp => camp.dueDiligenceRequired === "Yes");

    if (dueDiligenceCampaigns.length === 0) {
      this.alertService.showMessage('Due Diligence Campaigns', 'No due diligence campaigns available', MessageSeverity.info);
      return;
    }

    const campaignList = dueDiligenceCampaigns
      .map(camp => `• ${camp.campaignName} (${camp.name})`)
      .join('\n');

    Swal.fire({
      title: 'Due Diligence Campaigns',
      html: `<div style="text-align: left; margin: 20px 0;">
        <p><strong>Available Due Diligence Campaigns:</strong></p>
        <pre style="white-space: pre-wrap; word-wrap: break-word; background-color: #f5f5f5; padding: 15px; border-radius: 4px; max-height: 400px; overflow-y: auto;">
${campaignList}
        </pre>
        <p style="font-size: 12px; color: #666; margin-top: 15px;">
          Select "Yes" above and then choose a Promoting Owner and New ICD Owner to see associated campaigns.
        </p>
      </div>`,
      icon: 'info',
      confirmButtonText: 'Close',
      width: '600px'
    });
  }

  private resetDueDiligenceSelection(): void {
    this.selected_AccPo = "";
    this.searchText = "";
    this.filteredOwners = [];
    this.isPOICDNO = false;
    this.isrepLoading = false;
    this.AccPoRepdata = [];
    this.AccPoRepdataNF = [];
    this.resetRepAndCampaignSelection();
  }

  private resetRepAndCampaignSelection(): void {
    this.selected_AccPoRep = "";
    this.repdata = [];
    this.campsdatafilter = [];
    this.Campaigns_selectedItems = [];
    this.Campaigns_isSelectedItemsinvalid = false;
  }

  private isClosedWithin90Days(rep: any): boolean {
    const rawDate =
      rep?.closed_Date__c ?? rep?.closedDate ?? rep?.closed_date ??
      rep?.Closed_Date__c ?? rep?.ClosedDate ?? null;
    if (!rawDate) {
      return true;
    }
    let parsed = Date.parse(String(rawDate));
    if (isNaN(parsed)) {
      const idx = String(rawDate).indexOf('T');
      if (idx > 0) {
        parsed = Date.parse(String(rawDate).substring(0, idx));
      }
    }
    if (isNaN(parsed)) {
      return false;
    }
    const diffDays = (new Date().getTime() - parsed) / (1000 * 60 * 60 * 24);
    return diffDays <= 90;
  }

  formatDate(dateString: string): string {
    if (dateString && typeof dateString === 'string') {
      const dateTimeParts = dateString.split('T');
      if (dateTimeParts.length === 2) {
        const datePart = dateTimeParts[0];
        const timePart = dateTimeParts[1].split('.')[0];
        const formattedDate = new Date(datePart + ' ' + timePart + 'Z').toLocaleString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
        return formattedDate;
      }
    }
    return dateString;
  }

  private mapDataToICD(data: any) {
    if (data == null) {

      this.icdForm.disable();
      this.alertService.showMessage('ICD', `This Case is not assigned to view`, MessageSeverity.error);
      this.alertService.startLoadingMessage('', 'This Case is not assigned to view');
      this.alertService.showStickyMessage('ICD', 'This Case is not assigned to view', MessageSeverity.error, "");
      this.btnDisplay = false;

      return;
    }
    //debugger;
    this.icdForm.controls['US_or_CA'].setValue(data.uS_or_CA);
    this.onCountryChange();
    this.icdForm.controls['Full_Legal_Company_Name'].setValue(data.full_Legal_Company_Name);
    this.icdForm.controls['Tax_ID'].setValue(data.tax_ID);
    this.icdForm.controls['State_of_Incorporation'].setValue(data.state_of_Incorporation);
    this.icdForm.controls['Provinence_of_Incorporation'].setValue(data.provinence_of_Incorporation);
    this.icdForm.controls['Owner_First_Name'].setValue(data.owner_First_Name);
    this.icdForm.controls['Owner_Middle_Name'].setValue(data.owner_Middle_Name);    
    this.icdForm.controls['Owner_Last_Name'].setValue(data.owner_Last_Name);
    this.icdForm.controls['Owner_Preferred_First_Name'].setValue(data.owner_Preferred_First_Name);
    this.icdForm.controls['Owner_Preferred_Last_Name'].setValue(data.owner_Preferred_Last_Name);
    this.icdForm.controls['Owner_Email'].setValue(data.owner_Email);

    this.icdForm.controls['HUB_Manager_Contact_Name'].setValue(data.huB_Manager_Contact_Name);
    this.icdForm.controls['HUB_Manager_Contact_Number'].setValue(data.huB_Manager_Contact_Number);     
    this.icdForm.controls['HUB_Manager_Contact_Email'].setValue(data.huB_Manager_Contact_Email);
    ////console.log(data);
    this.icd.Full_Legal_Company_Name = data.full_Legal_Company_Name;
    this.icd.AccountID = data.accountID;
    this.icd.HUB_Manager_Contact = data.hub_C;
    this.icd.CaseID = data.caseID;
    this.icd.ContactID = data.contactID;

    this.icd.HUB_Manager_Contact = data.huB_Manager_Contact;
    this.icd.HUB_Manager_Contact_Name = data.huB_Manager_Contact_Name;
    this.icd.HUB_Manager_Contact_Number = data.huB_Manager_Contact_Number;
    this.icd.HUB_Manager_Contact_Email = data.huB_Manager_Contact_Email;
    this.icd.HUB_Assistance_Email = data.huB_Assistance_Email;
    this.icd.Owner_First_Name = data.owner_First_Name;
    this.icd.Owner_Middle_Name = data.owner_Middle_Name;
    this.icd.Owner_Last_Name = data.owner_Last_Name;
    this.icd.Owner_Name = data.owner_Name;
    this.icd.Owner_Preferred_First_Name = data.owner_Preferred_First_Name; 
    if (data.attachments != null) {
      for (let i = 0; i < data.attachments.length; i++) {
        const file = data.attachments[i];

        this.fileData.push({ attachment_FileName: file.attachment_FileName, attachment_Base64: file.attachment_Base64, attachment_Type: file.attachment_Type });
      }

    }
    this.onIsPreferChange('Yes');
    this.icdForm.controls['Is_Preferred_Differ'].setValue('Yes');
    
     
    this.dataEmitter.emit(this.datad);


  }

  BindData(id: string) {
    //debugger;

    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');
    //this.icd.Owner_Email = this.icdForm.value["Owner_email"];
    if (this.f != null && this.d != null) {
      this.sfDataService.getICDStep3byAcc(id)
        .subscribe(
          data => {
            ////console.log(data);
            //debugger;

            this.mapDataToICD(data);
            ////console.log(data);


            this.alertService.stopLoadingMessage();
          },
          error => {

            this.alertService.stopLoadingMessage();

            if (Utilities.checkNoNetwork(error)) {
              this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
              this.offerAlternateHost();
            } else {
              const errorMessage = Utilities.getHttpResponseMessage(error);

              if (errorMessage) {
                this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
              } else {
                this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
              }
            }

            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          });
}
    else {
      this.sfDataService.getICDStep3(id)
        .subscribe(
          data => {
            ////console.log(data);
            //debugger;

            this.mapDataToICD(data);
            ////console.log(data);


            this.alertService.stopLoadingMessage();
          },
          error => {

            this.alertService.stopLoadingMessage();

            if (Utilities.checkNoNetwork(error)) {
              this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
              this.offerAlternateHost();
            } else {
              const errorMessage = Utilities.getHttpResponseMessage(error);

              if (errorMessage) {
                this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
              } else {
                this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
              }
            }

            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          });
}
    
  }

  mapLoginErrorMessage(error: string) {

    if (error === 'invalid_username_or_password') {
      return 'Invalid username or password';
    }

    if (error === 'invalid_grant') {
      return 'This account has been disabled';
    }

    return error;
  }

  offerAlternateHost() {

    if (Utilities.checkIsLocalHost(location.origin) && Utilities.checkIsLocalHost(this.configurations.baseUrl)) {
      this.alertService.showDialog('Dear Developer!\nIt appears your backend Web API service is not running...\n' +
        'Would you want to temporarily switch to the online Demo API below?(Or specify another)',
        DialogType.prompt,
        (value: string) => {
          this.configurations.baseUrl = value;
          this.alertService.showStickyMessage('API Changed!', 'The target Web API has been changed to: ' + value, MessageSeverity.warn);
        },
        null,
        null,
        null,
        this.configurations.fallbackBaseUrl);
    }
  }

  trimFormValues() {

    Object.keys(this.icdForm.controls).forEach(key => {

      const control = this.icdForm.get(key);

      if (
        control &&
        typeof control.value === 'string'
      ) {

        control.setValue(control.value.trim());
      }
    });
  }

  noHtmlTagsValidator(control: any) {

    if (!control.value) {
      return null;
    }

    const value = control.value.toString().trim();

    const htmlPattern =
      /(<[^>]+>|&lt;|&gt;|javascript:|onerror=|onload=|<script|<\/script>)/gi;

    if (htmlPattern.test(value)) {
      return { invalidHtml: true };
    }

    return null;
  }

  reset() {
    this.formResetToggle = false;

    setTimeout(() => {
      this.formResetToggle = true;
    });
  }
  buildFormSnapshot(): Record<string, string> {
    const raw = this.icdForm.getRawValue();
    const snap: Record<string, string> = {};
    Object.keys(raw).forEach(k => {
      const ctrl = this.icdForm.get(k);
      if (ctrl && ctrl.disabled) { return; } // skip disabled/read-only fields — user cannot act on the advisory
      const v = raw[k];
      if (v !== null && v !== undefined && v !== '' && typeof v !== 'object') {
        snap[k] = String(v);
      }
    });
    return snap;
  }

  runPreSubmitReview(): void {
    this.preSubmitLoading = true;
    this.preSubmitIssues = [];
    const snapshot = this.buildFormSnapshot();
    this.agentService.getPreSubmitReview(snapshot).pipe(
      catchError(() => of({ issues: [] }))
    ).subscribe(res => {
      this.preSubmitIssues = res?.issues ?? [];
      this.preSubmitLoading = false;
    });
  }

  onPreSubmitDismiss(): void { this.showPreSubmitReview = false; }

  onPreSubmitDoSubmit(): void {
    this.showPreSubmitReview = false;
    this.saveData(true);
  }

  onPreSubmitRecheck(): void { this.runPreSubmitReview(); }

  onPreSubmitAutoFix(fix: { fieldName: string; suggestedFix: string }): void {
    const ctrl = this.icdForm.get(fix.fieldName);
    if (ctrl) { ctrl.setValue(fix.suggestedFix); ctrl.markAsDirty(); }
  }

  onPreSubmitNavigate(fieldName: string): void {
    const el = document.getElementById(fieldName) || document.querySelector(`[formcontrolname="${fieldName}"]`);
    if (el) (el as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'center' });
  }


}


